import React, { useState } from 'react'

import { Spinner } from '@nextui-org/react'

import fakeData from '@/utils/fakeData'
import useIntersectionObserver from '@/hooks/useScrollBottom'
import { useGetCommentQuery } from '@/redux/api/feed/feed.w3api'
import { PostCommentPayload } from '@/redux/reducers/feed/feed.type'

import CommentItem from './CommentItem'

const renderFakeData = () => {
  return (
    <>
      {fakeData(3).map((_, index) => (
        <div className="mt-2 flex w-full gap-[32px]" key={index}>
          <div className="h-[46px] w-[46px] animate-pulse rounded-full bg-gray-300" />
          <div className="flex w-full flex-1 flex-col gap-2">
            <div className="h-[20px] w-full animate-pulse rounded-lg bg-gray-300" />
            <div className="h-[20px] w-full animate-pulse rounded-lg bg-gray-300" />
          </div>
        </div>
      ))}
    </>
  )
}
export const ListComment = ({ postId }: { postId: string }) => {
  const [page, setPage] = useState(0)
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false)
  const { data: comments, isFetching } = useGetCommentQuery({ postId, size: 10, page }, { skip: !postId })

  const loadMore = () => {
    if (!isFetching && comments?.meta?.hasNext && !isLoadingMore) {
      setIsLoadingMore(true)
      setPage((prev) => prev + 1)
    } else {
      setIsLoadingMore(false)
    }
  }

  const lastElementRef = useIntersectionObserver(loadMore)

  if (isFetching && page === 1) {
    return renderFakeData()
  }

  return (
    <>
      {comments &&
        comments.data.length > 0 &&
        comments.data.map((item: PostCommentPayload, index: number) => (
          <CommentItem key={index} data={item} index={index} />
        ))}
      {isFetching && page > 1 && renderFakeData()}
      {!isFetching && <div ref={lastElementRef} />}

      {isLoadingMore && (
        <div className="flex items-center justify-center">
          <Spinner className="flex items-center justify-center" />
        </div>
      )}
    </>
  )
}
